
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]",
      function () {
        return require("private-next-pages/[lang]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]"])
      });
    }
  